"use client";

import { Container, Typography } from "@mui/material";
import { useIntl } from "react-intl";

import { ViewBoxAppBar } from "@/widgets/app-bar/ui/app-bar.js";
import { ViewBoxAppBarBackButton } from "@/widgets/app-bar/ui/app-bar-back-button.js";

export const ShowBlocked = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <ViewBoxAppBar primaryAction={<ViewBoxAppBarBackButton />} title={""} />

      <Container
        maxWidth="lg"
        disableGutters
        sx={(theme) => ({
          [theme.breakpoints.up("lg")]: {
            px: 3,
          },
        })}
      >
        <Typography>
          {formatMessage({ id: "content_not_available" })}
        </Typography>
      </Container>
    </>
  );
};
